module.exports = "https://www.gc-pro.gnp.com.mx/32f7fd3f51bebefa1032c85a3ec0fa5c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/01-descargar.svg
// module id = 932
// module chunks = 0